import * as GladlyHelpApp from 'GladlyHelpApp';

// Whitelist of functions that should be exposed in our public facing API
const LIB_FUNCS = ['getAvailability', 'navigate', 'on', 'show'];

// Initial stub of the public API
const apiBootstrap = {
  init: config => {
    let originalInit = apiBootstrap.init; // stores the original init function
    delete apiBootstrap.init; // delete init so cannot be called twice
    config.loaderCdn = apiBootstrap.loaderCdn;
    return new Promise((resolve, reject) => {
      GladlyHelpApp.init(config)
        .then(() => {
          delete apiBootstrap.loaderCdn;
          exposeApiFunctions();
          resolve();
        })
        .catch(err => {
          apiBootstrap.init = originalInit; // if promise fails, add init back
          reject(err);
        });
    });
  },
};

export default apiBootstrap;

/**
 * Map the whitelisted API functions from GladlyHelpApps to the publicly exposed apiBootstrap
 * This is a way to control what functions we will give developer access to.
 */
const exposeApiFunctions = () => {
  for (let func = LIB_FUNCS[0], i = 0; i < LIB_FUNCS.length; func = LIB_FUNCS[++i]) {
    apiBootstrap[func] = GladlyHelpApp[func]; // eslint-disable-line import/namespace
  }
};
